import type { TPageTranslations } from '@crehana/i18n';

import { CANDIDATE_FORM } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof CANDIDATE_FORM> = {
  [CANDIDATE_FORM]: {
    PUBLISHED: 'Publicado: {{datePublished}}',
    SPACE: ' | ',
    APPLY: 'Aplicar',
    APPLICATION_FORM: 'Formulário de candidatura',
    WORK_MODE_VIRTUAL: 'Remoto',
    WORK_MODE_ONSITE: 'Presencial',
    WORK_MODE_HYBRID: 'Híbrido',
    CONTRACT_LEARNING: 'Aprendizagem / Práticas',
    CONTRACT_FIXED: 'Término fixo',
    CONTRACT_INDEFINITE: 'Término indefinido',
    CONTRACT_SERVICE: 'Prestador de serviços / Freelance',
    CONTRACT_WORK: 'Obra labor',
    NAMES: 'Nome (s)',
    REQUIRED_ICON: ' *',
    REQUIRED_FIELDS: 'Campos obrigatórios',
    LAST_NAME: 'Sobrenome (s)',
    EMAIL: 'Email',
    NUMBER_PHONE: 'Número de telefone',
    DESCRIPTION_PHONE:
      'Adicione seu número de telefone apenas com números (sem parênteses, hífens nem espaços). Selecione o código do país.',
    COUNTRY: 'País de residência',
    CURRICULUM: 'Carregue seu currículo',
    CURRICULUM_DESCRIPTION:
      'Carregue seu CV em formato PDF com um peso máximo de 5Mb. Certifique-se de que o texto seja selecionável e não uma imagem.',
    UPLOAD_ATTACHMENT: 'Carregar arquivo',
    LINKEDIN: 'LinkedIn',
    PLACEHOLDER_LINKEDIN: 'URL (Linkedin)',
    REQUIRED_FIELD: 'Campo obrigatório',
    INVALID_EMAIL: 'Email inválido',
    MAX_LENGTH_EXCEEDED: 'Máximo de caracteres excedido',
    YES: 'Sim',
    NO: 'Não',
    SPACE_FOR_TEXT: 'Espaço para escrever texto',
    SPACE_FOR_NUMERIC: 'Espaço para escrever número',
    SEND_APPLICATION: 'Enviar candidatura',
    FILE_EXCEEDS_LIMIT:
      'O arquivo selecionado excede o limite de peso máximo de 5mb.',
    ERROR_TO_CREATE_JOB_APPLICANT_PROFILE:
      'Erro ao criar o perfil de candidato',
    ERROR_PAGE_TITLE_CANDIDATE_FORM: 'Ocorreu um erro',
    ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM:
      'Clique no botão para tentar carregar novamente.',
    RETRY: 'Tentar novamente',
    INVALID_PHONE: 'Número de telefone inválido',
    WORK_SCHEDULE_PART_TIME: 'Tempo parcial',
    WORK_SCHEDULE_FULL_TIME: 'Tempo completo',
    CANDIDATE_FORM_STATUS_TITLE_CLOSED: 'A chamada terminou',
    CANDIDATE_FORM_STATUS_SUBTITLE_CLOSED: '¡Obrigado pelo seu interesse!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_CLOSED:
      'Muito em breve estaremos publicando novas oportunidades laborais.',
    CANDIDATE_FORM_STATUS_TITLE_SUCCESS: '¡Recebemos sua candidatura!',
    CANDIDATE_FORM_STATUS_SUBTITLE_SUCCESS:
      '¡Obrigado pelo seu interesse em trabalhar conosco!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_SUCCESS:
      'Em breve nos comunicaremos com você sobre o status da sua candidatura.',
    CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND: 'Formulário não encontrado',
    CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND:
      'Tente novamente em alguns minutos',
    EMAIL_VALIDATION_TITLE: 'Este email já foi utilizado para esta postulação.',
    EMAIL_VALIDATION_DESCRIPTION:
      'Este email já foi utilizado para esta postulação. Por favor, utilize um email diferente.',
    LOADING_SEND_APPLICATION: 'Enviando sua candidatura',
    INVALID_LINKEDIN_URL: 'URL do LinkedIn inválida',
    BANNER_PREVIEW_FORM:
      'Esta visualização do formulário é apenas informativa, portanto, não permite carregar arquivos ou enviá-lo.',
    LINKEDIN_VALIDATION_TITLE:
      'O link que você inseriu não parece ser um perfil válido do LinkedIn',
    LINKEDIN_VALIDATION_DESCRIPTION:
      'Certifique-se de copiar e colar uma URL completa, como:',
    EMAIL_BLOCKED_VALIDATION_TITLE: 'Você não pode se candidatar a esta vaga',
    EMAIL_BLOCKED_VALIDATION_DESCRIPTION:
      'Seu perfil não está habilitado para se candidatar a novas vagas neste momento.',
    BACK_TO_FORM: 'Voltar ao formulário',
    INVALID_PHONE_LENGTH: 'O número de telefone deve ter entre 5 e 15 dígitos',
    VALIDATION_ERROR:
      'A validação do formulário falhou. Por favor, revise os campos e tente novamente.',
  },
};
